import * as React from "react";
import * as ReactDOM from "react-dom";
import { extent as d3ArrayExtent, histogram } from "d3-array";
import { axisBottom as d3AxisBottom, axisLeft as d3AxisLeft } from "d3-axis";
import { min as d3min, max as d3max } from "d3";
import {
  scaleLinear as d3ScaleLinear,
  scalePoint as d3ScalePoint
} from "d3-scale";
import { select as d3Select, selectAll as d3SelectAll } from "d3-selection";
import { line as d3Line } from "d3-shape";
import YAxisTarget from "./GraphBorder";
import * as aggregation from "../aggregation/countAggregation";
import { func } from "prop-types";
import * as interactfuncs from "../../libtsx/interactfuncs";
import Histogram from "../Charts/Histogram/Histogram";
import BarChart from "../Charts/BarChart/BarChart";
import ScatterPlot from "../Charts/ScatterPlot/Scatterplot";
import LineChart from "../Charts/LineChart/LineChart";
import ParallelCoordinates from '../Charts/ParallelCoordinates/ParrallelCoordinates'
require("webpack-jquery-ui/interactions");
require("webpack-jquery-ui/widgets");
import { GraphPredictContext } from "./GraphPredictContext";
import {
  PREDICTION,
  ACTUAL,
  COMBINED,
  HISTOGRAM_CHART,
  BAR_CHART,
  SCATTERPLOT_CHART,
  LINE_CHART,
  PARALLEL_COORDINATES_CHART
} from "./Constants";
import {LogEvents} from '../../Globals/Globals'
interface ExpectationGraphState {
  xaxis: string;
  yaxis: string;
  height: number;
  width: number;
}

interface sizeProps {
  height: number;
  width: number;
}

interface ExpectationGraphProps {
  id: string;
  xaxis: string;
  yaxis: string;
  zaxis: string
  width: number;
  height: number;
  yaxisStatus: string;
  xaxisStatus: string;
  zaxisStatus: string;
  transform: string;
  changing: string;
  graphType: string;
  brushValueOptions: {};
  invert
}

const ExpectationGraph: React.FC<ExpectationGraphProps> = ({
  id,
  xaxis,
  yaxis,
  zaxis,
  width,
  height,
  xaxisStatus,
  yaxisStatus,
  zaxisStatus,
  transform,
  changing,
  graphType,

  brushValueOptions,
  invert
}) => {
  
  if (changing == "resize-rectY") {
    transform = transform;
  }

  if (changing == "resize-rectZ") {
    transform = transform;
  }
 
  const graphStyle = {
    top: 50 + "px",
    left: 0.25 * 320 + "px",
    width: width + "px",
    height: height + "px",
    transform: transform,
    position: "absolute" as "absolute"
  };
  console.log('uuugrpah',graphType,zaxisStatus,yaxisStatus,xaxisStatus);

  var graph: any;
    if (graphType == HISTOGRAM_CHART) {
        graph = (
          <Histogram
            id={id}
            width={width}
            height={height}
            xaxis={xaxis}
            yaxis={yaxis}
         
          ></Histogram>
        );
      
        console.log(graph)
      }
      if (graphType == BAR_CHART) {
        
        graph = (
          <BarChart
            id={id}
            width={width}
            height={height}
            xaxis={xaxis}
            yaxis={yaxis}
            brushValueOptions={brushValueOptions}
            invert={invert}
          ></BarChart>
        );
      }
      if (graphType == LINE_CHART) {
        graph = (
          <LineChart
            id={id}
            width={width}
            height={height}
            xaxis={xaxis}
            yaxis={yaxis}
            brushValueOptions={brushValueOptions}
          ></LineChart>
        );
      }
   
      if (graphType == SCATTERPLOT_CHART) {
        graph = (
          <ScatterPlot
            id={id}
            width={width}
            height={height}
            xaxis={xaxis}
            yaxis={yaxis}
        
            brushValueOptions={brushValueOptions}
          ></ScatterPlot>
        );
      }

      if (graphType == PARALLEL_COORDINATES_CHART) {
        graph = (
          <ParallelCoordinates
            id={id}
            width={width}
            height={height}
            axis={zaxis}
          ></ParallelCoordinates>
        );
    }
  
  return <div style={graphStyle}>{graph}</div>;
};

export default ExpectationGraph;

{
  /* <YAxisTarget id={ id} xaxis={ xaxis} yaxis={ yaxis} height={ height} width={ width} yaxisStatus={"Off"}></YAxisTarget>
   */
}
